import EmployeesCom from "../components/EmployeesCom";

function Archives(props) {
  return (
    <EmployeesCom type="nonActive"/>
  );
}

export default Archives;